import { supabase } from '../lib/supabase';

export const aiBillingService = {
  /**
   * Resolves the caller's currently active TEXT AI provider (same one used
   * by article generation) and, for DeepSeek, a fresh live balance — fetched
   * server-side so the API key never reaches the browser.
   */
  async getStatus() {
    try {
      const { data, error } = await supabase.functions.invoke('ai-billing-status', { body: {} });
      if (error) {
        let message = error.message || 'Request failed';
        try {
          const respBody = await error.context?.json();
          if (respBody?.error) message = respBody.error;
        } catch (_) { /* response wasn't JSON — fall back to error.message */ }
        throw new Error(message);
      }
      if (data?.error) throw new Error(data.error);
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  }
};
